export default "https://cdn.questicon.mathletics.com/assets/audio/click-3dc69016df32b81c636def29b021ec48.mp3";